import { Grid2 } from "@mui/material";
import FormFields from "pages/components/FormFields";
import CityInput from "pages/components/Molecules/CityInput";
import Section from "pages/components/Section";

export default function Location(props: any) {
  const {
    values,
    handleInputChange,
    options,
    formatErrorObject,
    errors,
    isMobile,
  } = props;

  return (
    <Section title={"location"}>
      <FormFields.Select
        name="country"
        value={values.country}
        onChange={handleInputChange}
        options={options.country}
        required
        {...formatErrorObject(errors.country)}
      />
      <CityInput
        name="city"
        country={values.country as string}
        value={values.city}
        onChange={handleInputChange}
        isMobile={isMobile}
        errors={formatErrorObject(errors.city)}
      />
      <Grid2
        display={"grid"}
        gridTemplateColumns={"1fr 1fr"}
        width={"100%"}
        gap={1}
        container
      >
        <FormFields.TextInput
          name="boxNumber"
          value={values.boxNumber}
          onChange={handleInputChange}
          required
          {...formatErrorObject(errors.boxNumber)}
        />
        <FormFields.TextInput
          name="box"
          value={values.box}
          onChange={handleInputChange}
          {...formatErrorObject(errors.box)}
        />
      </Grid2>
      <FormFields.TextInput
        name="address"
        value={values.address}
        onChange={handleInputChange}
        required
        {...formatErrorObject(errors.address)}
      />
    </Section>
  );
}
